import { DateTimeInputField } from './DateTimeInputField'
import { withDateTimeInputField } from './withDateTimeInputField'

const ConnectedDateTimeInputField = withDateTimeInputField(DateTimeInputField)

export { ConnectedDateTimeInputField as DateTimeInputField }
